import makeCrud from '@/store/site/localization/crud'

// Manager paket CRUD store'u (makeCrud: get/refresh/show/create/put/delete).
export default makeCrud('manager_package')
